/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.Rule = (function () {

    function Rule (form, id) {

        this.cardColor = new Monet.UI.Fields.ColorPicker();
        this.textColor = new Monet.UI.Fields.ColorPicker();
        this.ruleName = new Monet.UI.Fields.TextField();
        this.ruleConditions = {};
        this.entityToAction = form.entityToAction;
        this.priority = null;

        var clearLines = function () {

            this.ruleConditions = {};
            this.lineContainer.innerHTML = '';
            
        }.bind(this);

        this.setPriority = function (priority) {
            this.priority = priority;
        };

        this.setValue = function (value) {

            this.value = value;

            this.cardColor.setValue(value.cardColor);
            this.textColor.setValue(value.fontColor);
            this.ruleName.setValue(value.ruleName);

            clearLines();

            for (var i in value.panelRuleConditions) {
                var line = this.addRuleCondition();
                line.setValue(value.panelRuleConditions[i]);
            }

        };

        this.getValue = function () {

            var getRulesLineValues = function () {
                var lines = [];
                for (var key in this.ruleConditions) {
                    lines.push(this.ruleConditions[key].getValue());
                }

                return lines;

            }.bind(this);

            var value = {
                cardColor: this.cardColor.getValue(),
                fontColor: this.textColor.getValue(),
                rulePriority: this.priority,
                panelRuleConditions: getRulesLineValues(),
                ruleName: this.ruleName.getValue()
            };

            if (this.value && this.value.id) {
                value.id = this.value.id;
            }

            return value;

        }.bind(this);

        var getColorsAndNameSection = function () {
            var container = document.createElement('div');
            container.className = 'colors name';

            this.cardColor.setColor('#fff');
            this.textColor.setColor('white');

            container.appendChild(Greenmile.PanelBuilder.Utils.getBtnDragDropHandler());
            container.appendChild(this.ruleName.render());
            container.appendChild(this.cardColor.render());
            container.appendChild(this.textColor.render());

            this.cardColor.rootEl.querySelector('div.sp-preview-inner').setAttribute('title', Monet.I18n.getResourcesByKey('PanelBuilder.cardColor'));
            this.textColor.rootEl.querySelector('div.sp-preview-inner').setAttribute('title', Monet.I18n.getResourcesByKey('PanelBuilder.textColor'));

            var callbackDelete = function (e) {
                var thisContainer = e.target.parentNode.parentNode;
                thisContainer.parentNode.removeChild(thisContainer);

                delete form.rules[id];

            }.bind(this);

            const ruleDelete = Greenmile.PanelBuilder.Utils.getBtnDelete(callbackDelete);
            ruleDelete.classList.add("first");

            container.appendChild(ruleDelete);

            return container;
        }.bind(this);

        this.addRuleCondition = function () {

            var ruleUuid = uuid.v1();
            var ruleCondition = new Greenmile.PanelBuilder.RuleCondition(this, ruleUuid);
            this.ruleConditions[ruleUuid] = ruleCondition;
            this.lineContainer.appendChild(ruleCondition.render());
            this.lineContainer.focus();

            var panelForm = document.querySelector('.MonetUIForm.PanelBuilder');
            if (panelForm) {
                panelForm.scrollTop = this.lineContainer.getBoundingClientRect().bottom;
            }

            return ruleCondition;
        }.bind(this);

        this.render = function () {
            this.rootEl = document.createElement('div');
            this.lineContainer = document.createElement('div');

            this.rootEl.className = 'rule';
            this.rootEl.setAttribute('data-id', id);
            this.lineContainer.className = 'lineContainer';

            this.rootEl.appendChild(getColorsAndNameSection());
            this.rootEl.appendChild(this.lineContainer);
            this.rootEl.appendChild(Greenmile.PanelBuilder.Utils.getBtnNewItem('PanelBuilder.newCondition', this.addRuleCondition));

            return this.rootEl;
        };

    }

    return Rule;

}());
